import classes from "./index.module.scss";

export default function Tag({
  tag,
  toggleActiveTag,
  checkIsTagActive,
  setPage,
  entity,
}) {
  return (
    <button
      onClick={() => {
        setPage(1);
        toggleActiveTag(tag, entity);
      }}
      className={`${classes.tag} ${
        checkIsTagActive(tag, entity) ? classes.tag_active : ""
      }`}
    >
      {tag.name}
    </button>
  );
}
